import React from 'react';

import PlainInput from '../plain';

const PasswordInput = ({ field, ...props }) => (
  <PlainInput {...props} field={{ ...field, name: 'password' }} id="password" placeholder="Password" /* autoComplete="new-password" */ type="password" />
);

export default PasswordInput;
